module.exports = __webpack_public_path__ + "static/img/swiper_02.763a62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper_02.png
// module id = kTpU
// module chunks = 1